// ─────────────────────────────────────────────
//  OptionalFees.jsx
//  Campos opcionales: comisión de manejo e ISR
//  Ambos reducen el rendimiento neto.
// ─────────────────────────────────────────────

import React from 'react';
import styles from './OptionalFees.module.css';

function FeeInput({ id, label, hint, value, onChange, placeholder = '0' }) {
	const handleChange = (e) => {
		const raw = e.target.value.replace(/[^0-9.]/g, '');
		const parts = raw.split('.');
		if (parts.length > 2) return;
		if (parts[1] !== undefined && parts[1].length > 2) return;
		if (parseFloat(raw) > 100) return;
		onChange(raw);
	};

	return (
		<div className={styles.field}>
			<label className={styles.fieldLabel} htmlFor={id}>
				{label}
				<span className={styles.optional}>opcional</span>
			</label>
			{hint && <p className={styles.hint}>{hint}</p>}
			<div className={styles.inputWrap}>
				<input
					id={id}
					className={styles.input}
					type="text"
					inputMode="decimal"
					value={value}
					placeholder={placeholder}
					aria-label={label}
					onChange={handleChange}
				/>
				<span className={styles.suffix} aria-hidden="true">%</span>
			</div>
		</div>
	);
}

export default function OptionalFees({ comision, onComisionChange, isr, onIsrChange }) {
	return (
		<section className={styles.card} aria-label="Deducciones opcionales">
			<p className={styles.sectionLabel}>Deducciones</p>

			<div className={styles.fields}>
				<FeeInput
					id="comision"
					label="Comisión de manejo"
					hint="% anual que cobra la institución"
					value={comision}
					onChange={onComisionChange}
					placeholder="0"
				/>
				<FeeInput
					id="isr"
					label="ISR estimado"
					hint="% sobre la ganancia"
					value={isr}
					onChange={onIsrChange}
					placeholder="0"
				/>
			</div>
		</section>
	);
}
